import './MicroservicesExplorerPage.css';

import { Box } from '@mui/material';
import Banner from '../../b2b-common/Banner';
import useGettingMicroservices from '../hooks/useGettingMicroservices';
import B2BElementsExplorerInMemory from '../../b2b-common/B2BElementsExplorerInMemory';
import MicroserviceCard from '../components/MicroserviceCard';
import { useState } from 'react';
import WaitingSpinner from '../../b2b-common/WaitingSpinner';

const MicroservicesExplorerPage = () => {
    const { microservices, error, loading } = useGettingMicroservices(180000); // 3 minutes
    const [page, setPage] = useState(1);
    if (loading)
        return <WaitingSpinner loading={loading} message={'Loading Microservices...'} />;
    if (!microservices || microservices.length === 0) 
        return <Banner message={'No Microservices found'} headingLevel='h2' />;
    return (
        <Box className="microservices-explorer-page" width={'100%'} display={'flex'} flexDirection={'column'} gap={2} boxSizing={'border-box'} >
            <Banner sectionTittle={'System'} message={'Microservices Explorer'} headingLevel='h1' />
            <Banner message={'Registered Microservices'} underline={false} headingLevel='h2' />
            <B2BElementsExplorerInMemory
                numRows={16}
                elementsData={{ content: microservices }}
                className='microservices-explorer-page-elements'
                ElementComponent={MicroserviceCard}
                elementComponentPropName={'microservice'}
                elementComponentHandlers={{

                }}
                currentPage={page}
            />            
        </Box>
    );
}

export default MicroservicesExplorerPage;